import { Button } from 'canoe';
import Cookies from 'js-cookie';
import React from 'react';

import { COOKIES } from './types';

export interface StagingButtonProps {
  asset: string;
  assetType: COOKIES;
}

export const StagingButton: React.FC<StagingButtonProps> = ({
  asset,
  assetType,
}: StagingButtonProps) => {
  const hasCookie = Cookies.get(assetType) === asset;
  const onClick = () =>
    hasCookie
      ? Cookies.remove(assetType, { domain: '.candu.ai' })
      : Cookies.set(assetType, asset, { domain: '.candu.ai' });

  return (
    <Button
      fullWidth
      variant={hasCookie ? 'warning' : 'secondary'}
      onClick={() => {
        onClick();
        window.location.reload();
      }}
    >
      {hasCookie ? 'Stop Testing' : 'Test Service'}
    </Button>
  );
};
